import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/AppShell";
import { DOCS, DRAFT_NOTE, LEGAL_VERSION } from "@/pages/legalContent";

export const LEGAL_LINKS = [["privacy", "Privacy Policy"], ["terms", "Terms of Service"], ["health-data", "Health Data Policy"]];

export const LegalLinks = ({ className = "" }) => (
  <span className={`inline-flex flex-wrap gap-x-4 gap-y-1 ${className}`}>
    {LEGAL_LINKS.map(([k, l]) => <Link key={k} to={`/legal/${k}`} data-testid={`legal-link-${k}`} className="tap hover:text-stone-800 underline-offset-2 hover:underline">{l}</Link>)}
  </span>
);

const Section = ({ s }) => (
  <section className="mt-8">
    <h2 className="font-display text-xl text-stone-900">{s.h}</h2>
    <div className="mt-2 space-y-2 text-[15px] leading-relaxed text-stone-700">{s.p.map((t) => <p key={t}>{t}</p>)}</div>
  </section>
);

export default function Legal() {
  const { doc } = useParams();
  const d = DOCS[doc];
  if (!d) return <Navigate to="/legal/privacy" replace />;
  return (
    <div className="grain min-h-screen">
      <div className="relative z-10 max-w-3xl mx-auto px-6 py-10" data-testid={`legal-page-${doc}`}>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-10">
          <Link to="/" data-testid="legal-back-link" className="flex items-center gap-2 text-sm text-stone-600"><ArrowLeft className="h-4 w-4" /><Logo className="!text-base" /></Link>
          <LegalLinks className="text-xs text-stone-500" />
        </div>
        <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="legal-draft-banner">{DRAFT_NOTE}</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-8" data-testid="legal-title">{d.title}</h1>
        <p className="text-xs text-stone-500 mt-2">{LEGAL_VERSION}</p>
        <p className="mt-6 text-stone-700 leading-relaxed">{d.intro}</p>
        {d.sections.map((s) => <Section key={s.h} s={s} />)}
      </div>
    </div>
  );
}
